import { Transform, Type } from 'class-transformer';
import { UserAddressModel } from 'src/lib/services/utility/utility-models/address.model';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import { FieldRequiredValue } from 'src/lib/utilities/api/patterns/dynamic-fields/field-required-value.enum';
import { FieldSelectModel_ClassTransform_TransformFactory } from 'src/lib/utilities/api/patterns/dynamic-fields/field-select.model';
import { FieldModel_ClassTransform_Type } from 'src/lib/utilities/api/patterns/dynamic-fields/field.model';
import {
	StringEnumOption,
	StringEnumOption_ClassTransform_Type,
} from 'src/lib/utilities/api/patterns/dynamic-fields/string-enum-option.model';
import { StudentContactAttributes } from '../../students/contacts/student-contact-options.model';
import { StudentInformationUpdateAddressOptionSubfieldsModel } from '../../students/student-information-update-options.model';
import {
	ContactFieldPhoneModel,
	ContactFieldValueModel,
} from '../contact-field.model';
import {
	UserDataContactAddressModel,
	UserDataPersonalContactPhoneModel,
	UserDataPersonalContactPhoneModel_ClassTransform_Type,
} from '../user-data.model';

export enum ProtectionLevel {
	open = 'open',
	restricted = 'restricted',
	controlled = 'controlled',
}

/*
 *
 * Request Model
 *
 */
export class UserUpdateRequestProfileStringModel {
	new: string;
	old: string;
	proofs: { proof_id: number; url: string }[];
}
export function UserUpdateRequestProfileStringModel_ClassTransform_Type() {
	return UserUpdateRequestProfileStringModel;
}

export class UserUpdateProfileModel {
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	profile_first_name: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	profile_middle_name: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	profile_last_name: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	profile_maiden_name: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	profile_preferred_name: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	profile_suffix: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	profile_student_gender: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	profile_field_race: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	profile_employee_id: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	profile_user_title: UserUpdateRequestProfileStringModel;
}
export function UserUpdateProfileModel_ClassTransform_Type() {
	return UserUpdateProfileModel;
}

export class UserUpdateStudentDataDobModel {
	@Transform(dateTransformer)
	new: Date;
	@Transform(dateTransformer)
	old: Date;
}
export function UserUpdateStudentDataDobModel_ClassTransform_Type() {
	return UserUpdateStudentDataDobModel;
}

export class UserUpdateStudentDataModel {
	@Type(UserUpdateStudentDataDobModel_ClassTransform_Type)
	dob: UserUpdateStudentDataDobModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	cohort_year: UserUpdateRequestProfileStringModel;
	student_given_id: { new: string; old: string };
	language_home: { new: string; old: string };
	language_primary: { new: string; old: string };
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	attendance_class: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	grade: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	student_id: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	state_id: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	courses_concurrent: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	district_id: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	calculated_grade: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	graduation_plan: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	track: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	sr_pay_level: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	sr_pay_level_notes: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	more_other: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	district_residence: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	custom_district: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	timezone: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	throttle_status: UserUpdateRequestProfileStringModel;
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	student_location: UserUpdateRequestProfileStringModel;
}

export function UserUpdateStudentDataModel_ClassTransform_Type() {
	return UserUpdateStudentDataModel;
}

export function ContactFieldPhoneModel_ClassTransform_Type() {
	return ContactFieldPhoneModel;
}

export class UserUpdateStudentContactFieldPhoneModel {
	@Type(ContactFieldPhoneModel_ClassTransform_Type)
	new: ContactFieldPhoneModel[];
	@Type(ContactFieldPhoneModel_ClassTransform_Type)
	old: ContactFieldPhoneModel[];
}
export function UserUpdateStudentContactFieldPhoneModel_ClassTransform_Type() {
	return UserUpdateStudentContactFieldPhoneModel;
}

export class UserUpdateStudentContactFieldAddressCompareModel extends UserAddressModel {
	active: boolean;
}
export function UserUpdateStudentContactFieldAddressCompareModel_ClassTransform_Type() {
	return UserUpdateStudentContactFieldAddressCompareModel;
}

export class UserUpdateStudentContactFieldAddressModel {
	@Type(UserUpdateStudentContactFieldAddressCompareModel_ClassTransform_Type)
	new: UserUpdateStudentContactFieldAddressCompareModel;
	@Type(UserUpdateStudentContactFieldAddressCompareModel_ClassTransform_Type)
	old: UserUpdateStudentContactFieldAddressCompareModel;
}
export function UserUpdateStudentContactFieldAddressModel_ClassTransform_Type() {
	return UserUpdateStudentContactFieldAddressModel;
}

export class UserUpdateStudentContactFieldModel {
	@Type(UserUpdateStudentContactFieldPhoneModel_ClassTransform_Type)
	phone: UserUpdateStudentContactFieldPhoneModel;
	@Type(UserUpdateStudentContactFieldAddressModel_ClassTransform_Type)
	mailing_address: UserUpdateStudentContactFieldAddressModel;
	@Type(UserUpdateStudentContactFieldAddressModel_ClassTransform_Type)
	physical_address: UserUpdateStudentContactFieldAddressModel;
}
export function UserUpdateStudentContactFieldModel_ClassTransform_Type() {
	return UserUpdateStudentContactFieldModel;
}

export class UserUpdateStudentContactPersonalCompareModel {
	index?: number; // Used on the front end to keep track of each object during submission
	attributes: StudentContactAttributes[];
	link_id?: number;
	delete: boolean;
	name: string;
	@Type(UserDataPersonalContactPhoneModel_ClassTransform_Type)
	phones: UserDataPersonalContactPhoneModel[];
	emails: string[];
	relationship: string;
}
export function UserUpdateStudentContactPersonalCompareModel_ClassTransform_Type() {
	return UserUpdateStudentContactPersonalCompareModel;
}

export class UserUpdateStudentContactPersonalModel {
	@Type(UserUpdateStudentContactPersonalCompareModel_ClassTransform_Type)
	new: UserUpdateStudentContactPersonalCompareModel[];
	@Type(UserUpdateStudentContactPersonalCompareModel_ClassTransform_Type)
	old: UserUpdateStudentContactPersonalCompareModel[];
}

export function UserUpdateStudentContactPersonalModel_ClassTransform_Type() {
	return UserUpdateStudentContactPersonalModel;
}

export class UserUpdateStudentContactModel {
	@Type(UserUpdateStudentContactPersonalModel_ClassTransform_Type)
	personal: UserUpdateStudentContactPersonalModel;
}

export function UserUpdateStudentContactModel_ClassTransform_Type() {
	return UserUpdateStudentContactModel;
}

export class UserUpdateRequestLaptopOverrideModel {
	@Type(UserUpdateRequestProfileStringModel_ClassTransform_Type)
	throttle_status: UserUpdateRequestProfileStringModel;
}

export function UserUpdateRequestLaptopOverrideModel_ClassTransform_Type() {
	return UserUpdateRequestLaptopOverrideModel;
}

export class UserUpdateModel {
	@Type(UserUpdateProfileModel_ClassTransform_Type)
	profile: UserUpdateProfileModel;
	@Type(UserUpdateStudentDataModel_ClassTransform_Type)
	student_data: UserUpdateStudentDataModel;
	@Type(UserUpdateStudentContactFieldModel_ClassTransform_Type)
	contact_field: UserUpdateStudentContactFieldModel;
	@Type(UserUpdateStudentContactModel_ClassTransform_Type)
	contacts: UserUpdateStudentContactModel;
	@Type(UserUpdateRequestLaptopOverrideModel_ClassTransform_Type)
	laptop_override: UserUpdateRequestLaptopOverrideModel;
}

export function UserUpdateModel_ClassTransform_Type() {
	return UserUpdateModel;
}

export class UpdateRequestedModel {
	by: string;
	@Transform(dateTransformer)
	on: Date;
}

export function UpdateRequestedModel_ClassTransform_Type() {
	return UpdateRequestedModel;
}

export class UserUpdateRequestModel {
	id: number;
	uid: number;
	status: number;
	@Type(UpdateRequestedModel_ClassTransform_Type)
	requested: UpdateRequestedModel;
	completed: boolean;
	@Type(UserUpdateModel_ClassTransform_Type)
	updates: UserUpdateModel;
}

export function UserUpdateRequestModel_ClassTransform_Type() {
	return UserUpdateRequestModel;
}

export class ProofRequirementModel {
	required: boolean;
	description: string;
	protected_level: ProtectionLevel;
	file_key: string;
	title?: string; // Not included in API response, used on front end to display field name in proof modal
}

export function ProofRequirementModel_ClassTransform_Type() {
	return ProofRequirementModel;
}

/*
 *
 * Request Options
 *
 */
export class UpdateRequestFieldModel<T> {
	title: string;
	type: string;
	required: FieldRequiredValue;
	can_save: boolean;
	current_value: T;
	protection_level: ProtectionLevel;
	@Type(ProofRequirementModel_ClassTransform_Type)
	proof_requirement: ProofRequirementModel;
}

export function UpdateRequestFieldModel_ClassTransform_Type() {
	return UpdateRequestFieldModel;
}

export class UpdateRequestFieldOptionsArrayModel<
	TOption,
	TValue = TOption,
> extends UpdateRequestFieldModel<TValue> {
	options: TOption[];
}

export function UpdateRequestFieldOptionsArrayModel_ClassTransform_Type() {
	return UpdateRequestFieldOptionsArrayModel;
}

export class UpdateRequestFieldOptionsModel<
	TOption,
	TValue = string | number,
> extends UpdateRequestFieldModel<TValue> {
	options: Record<string | number, TOption>;
}

export function UpdateRequestFieldOptionsModel_ClassTransform_Type() {
	return UpdateRequestFieldOptionsModel;
}

export class UpdateRequestBirthdayFieldModel extends UpdateRequestFieldModel<Date> {
	minimum_age: number;
}

export function UpdateRequestBirthdayFieldModel_ClassTransform_Type() {
	return UpdateRequestBirthdayFieldModel;
}

export class UpdateRequestFieldAddressModel<
	T,
> extends UpdateRequestFieldModel<T> {
	subfields: StudentInformationUpdateAddressOptionSubfieldsModel;
}

export function UpdateRequestFieldAddressModel_ClassTransform_Type() {
	return UpdateRequestFieldAddressModel;
}

export class UserUpdateRequestContactOptions {
	@Type(UpdateRequestFieldOptionsArrayModel_ClassTransform_Type)
	phone: UpdateRequestFieldOptionsArrayModel<ContactFieldPhoneModel>;

	@Type(UpdateRequestFieldAddressModel_ClassTransform_Type)
	physical_address: UpdateRequestFieldAddressModel<UserDataContactAddressModel>;

	@Type(UpdateRequestFieldAddressModel_ClassTransform_Type)
	mailing_address: UpdateRequestFieldAddressModel<UserDataContactAddressModel>;

	@Type(UpdateRequestFieldModel_ClassTransform_Type)
	email: UpdateRequestFieldOptionsArrayModel<ContactFieldValueModel>;

	@Type(UpdateRequestFieldModel_ClassTransform_Type)
	messenger: UpdateRequestFieldModel<ContactFieldValueModel[]>;
}

export function UserUpdateRequestContactOptions_ClassTransform_Type() {
	return UserUpdateRequestContactOptions;
}

export class UserUpdateRequestProfileOptions {
	@Type(FieldModel_ClassTransform_Type)
	profile_first_name: UpdateRequestFieldModel<string>;

	@Type(FieldModel_ClassTransform_Type)
	profile_middle_name: UpdateRequestFieldModel<string>;

	@Type(FieldModel_ClassTransform_Type)
	profile_last_name: UpdateRequestFieldModel<string>;

	@Type(FieldModel_ClassTransform_Type)
	profile_preferred_name: UpdateRequestFieldModel<string>;

	@Type(FieldModel_ClassTransform_Type)
	profile_maiden_name: UpdateRequestFieldModel<string>;

	@Type(FieldModel_ClassTransform_Type)
	profile_suffix: UpdateRequestFieldModel<string>;

	@Transform(
		FieldSelectModel_ClassTransform_TransformFactory(
			StringEnumOption_ClassTransform_Type,
		),
	)
	profile_student_gender: UpdateRequestFieldOptionsArrayModel<StringEnumOption>;

	@Transform(
		FieldSelectModel_ClassTransform_TransformFactory(
			StringEnumOption_ClassTransform_Type,
		),
	)
	profile_field_race: UpdateRequestFieldOptionsArrayModel<StringEnumOption>;

	@Transform(
		FieldSelectModel_ClassTransform_TransformFactory(
			StringEnumOption_ClassTransform_Type,
		),
	)
	profile_field_ethnicity: UpdateRequestFieldOptionsArrayModel<StringEnumOption>;
	profile_student_year: UpdateRequestFieldModel<StringEnumOption>;
}

export function UserUpdateRequestProfileOptions_ClassTransform_Type() {
	return UserUpdateRequestProfileOptions;
}

export class UserUpdateRequestLaptopOverrideOptions {
	@Type(UpdateRequestFieldOptionsArrayModel_ClassTransform_Type)
	throttle_status: UpdateRequestFieldOptionsArrayModel<UserUpdateRequestProfileStringModel>;
}

export function UserUpdateRequestLaptopOverrideOptions_ClassTransform_Type() {
	return UserUpdateRequestLaptopOverrideOptions;
}

export class UserUpdateRequestStudentOptions {
	@Type(UpdateRequestBirthdayFieldModel_ClassTransform_Type)
	dob: UpdateRequestBirthdayFieldModel;
}

export function UserUpdateRequestStudentOptions_ClassTransform_Type() {
	return UserUpdateRequestStudentOptions;
}

export class UserUpdateRequestContactsOptions {
	@Type(FieldModel_ClassTransform_Type)
	personal: UpdateRequestFieldModel<UserUpdateStudentContactPersonalCompareModel>;
}

export function UserUpdateRequestContactsOptions_ClassTransform_Type() {
	return UserUpdateRequestStudentOptions;
}

export class UpdateUserRequestUserOptionsThemeModel {
	key: string;
	title: string;
	color: string;
}

export function UpdateUserRequestUserOptionsThemeModel_ClassTransform_Type() {
	return UserUpdateRequestStudentOptions;
}

export class UpdateUserRequestUserOptionsTimezoneModel {
	key: string;
	title: string;
}

export class UserUpdateRequestUserOptions {
	@Type(UpdateRequestFieldOptionsArrayModel_ClassTransform_Type)
	theme: UpdateRequestFieldOptionsArrayModel<UpdateUserRequestUserOptionsThemeModel>;
	@Type(UpdateRequestFieldOptionsArrayModel_ClassTransform_Type)
	student_theme: UpdateRequestFieldOptionsArrayModel<UpdateUserRequestUserOptionsThemeModel>;
	@Type(UpdateRequestFieldOptionsArrayModel_ClassTransform_Type)
	mobile_theme: UpdateRequestFieldOptionsArrayModel<UpdateUserRequestUserOptionsThemeModel>;
	@Type(UpdateRequestFieldOptionsArrayModel_ClassTransform_Type)
	admin_type: UpdateRequestFieldOptionsArrayModel<string>;
	@Type(UpdateRequestFieldOptionsModel_ClassTransform_Type)
	timezone: UpdateRequestFieldOptionsModel<
		UpdateUserRequestUserOptionsTimezoneModel,
		string
	>;
}

export function UserUpdateRequestUserOptions_ClassTransform_Type() {
	return UserUpdateRequestUserOptions;
}

export class UserUpdateRequestOptions {
	@Type(UserUpdateRequestContactOptions_ClassTransform_Type)
	contact_field: UserUpdateRequestContactOptions;

	@Type(UserUpdateRequestProfileOptions_ClassTransform_Type)
	profile: UserUpdateRequestProfileOptions;

	@Type(UserUpdateRequestStudentOptions_ClassTransform_Type)
	student_data: UserUpdateRequestStudentOptions;

	@Type(UserUpdateRequestContactsOptions_ClassTransform_Type)
	contacts: UserUpdateRequestContactsOptions;

	@Type(UserUpdateRequestUserOptions_ClassTransform_Type)
	user: UserUpdateRequestUserOptions;

	@Type(UserUpdateRequestLaptopOverrideOptions_ClassTransform_Type)
	laptop_override: UserUpdateRequestLaptopOverrideOptions;
}

export function UserUpdateRequestOptions_ClassTransform_Type() {
	return UserUpdateRequestOptions;
}

/*
 *
 * Response
 *
 */
export class UsersRequestOptionsResponse {
	success: boolean;

	@Type(UserUpdateRequestOptions_ClassTransform_Type)
	allowed_updates: UserUpdateRequestOptions;
}

export class UsersPendingRequestsResponse {
	success: boolean;

	@Type(UserUpdateRequestModel_ClassTransform_Type)
	pending_update_requests: UserUpdateRequestModel[];
}

export const UserModelFields = new Map<string, string>([
	['profile_first_name', 'first_name'],
	['profile_middle_name', 'middle_name'],
	['profile_last_name', 'last_name'],
	['profile_maiden_name', 'maiden_name'],
	['profile_preferred_name', 'preferred_name'],
	['profile_pronunciation', 'pronunciation'],
	['profile_suffix', 'suffix'],
	['profile_birthdate', 'birthdate'],
	['phone', 'phone_numbers'],
	['email', 'email'],
	['mailing_address', 'mailing_address'],
	['physical_address', 'physical_address'],
	['dob', 'birthdate'],
	['profile_student_gender', 'gender'],
	['profile_field_race', 'race'],
	['profile_field_ethnicity', 'ethnicity'],
]);
